import React from "react"

export default function Service({title, icon}) {
  return (
    <li className={`services__item ico-${icon}`}>{title}</li>
  )
}
